import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import FamilyPlusLogo from './../../../../Assets/Parents/familyplus.svg'
import Coin from './../../../../Assets/Parents/coin.png'
import FamilyBooks from './../../../../Assets/Parents/FamilyBooks.png'
import LittleHaunt from './../../../../Assets/Parents/LittleHaunt.png'
import Haunt from './../../../../Assets/Parents/HauntWhite.png'
import HauntStory from './../../../../Assets/Parents/hauntStory.png'
import HauntEssay from './../../../../Assets/Parents/HauntEssay.png'
import HauntJournal from './../../../../Assets/Parents/HauntJournal.png'
import the2021 from './../../../../Assets/Parents/the2021.png'

import 'react-lazy-load-image-component/src/effects/blur.css';


import styles from './FamilyPlus.module.scss'
import { Link } from 'react-router-dom';

const FamilyPlus = () => {
  return (
    <section className={styles.familyPlusSection}>

      <div className={styles.strip}>
        <h1>Get your child writing even more by upgrading to a Family+ account!</h1>
        <LazyLoadImage wrapperClassName={styles.logoDeco} src={FamilyPlusLogo} alt="Family Plus logo" height={160} />

      </div>

      <div className={styles.blueContainer}>

        <div className={styles.familyTitle}>
          <div className={styles.title}>
            <LazyLoadImage src={FamilyPlusLogo} alt="Family Plus logo" height={79} />
            <h1>Escribli Family+</h1>
          </div>
          <h2>Continue building your child’s love of writing@home by upgrading to Family+ and gaining these benefits:</h2>
          <h2>Only $14.95 per month!</h2>
        </div>

        <div className={styles.gridContainer}>

          <div className={`${styles.familyFeature} ${styles.big}`}>
            <div className={styles.featureHeader}>
              <div className={styles.image}>
                <LazyLoadImage src={LittleHaunt} alt="Haun club logo" height={60} effect="blur" />
              </div>
              <h3>Unlimited access to <br />The Haunt Writing Club</h3>
            </div>
            <p>More writing leads to improved writing, and The Haunt’s high-interest activities are sure to inspire your child as they become a real published author!</p>
            <Link to="/auth/parent/signup" className={styles.orangeBtn}>Subscribe to Family+</Link>

          </div>

          <div className={`${styles.familyFeature}`}>
            <div className={styles.featureHeader}>
              <div className={styles.image}>
                <LazyLoadImage wrapperClassName={styles.image} src={FamilyBooks} alt="Books logo" height={70} effect="blur" />
              </div>
              <h3>Book discounts and digital copy of activities</h3>
            </div>
            <p>Families receive discounts on their child's personalized books and access to PDF downloads for printing and digital sharing.</p>
          </div>

          <div className={`${styles.familyFeature}`}>
            <div className={styles.featureHeader}>
              <div className={styles.image}>
                <LazyLoadImage wrapperClassName={styles.image} src={Coin} alt="A coin" height={43} effect="blur" />
              </div>
              <h3>Extra Boomer Bucks</h3>
            </div>
            <p>Your child will receive Boomer Bucks each month in addition to what they earn through consistently writing.</p>
          </div>

        </div>

        <div className={styles.hauntContainer}>
          <figure className={styles.hauntFigure}>
            <LazyLoadImage src={Haunt} alt="Haunt writing club" height={150} />
          </figure>
          <div className={styles.hauntText}>
            <h4>What's in The Haunt?</h4>
            <p>Run by professional educators who provide targeted writing feedback, The Haunt offers an assortment of monthly writing activities that will engage your child while developing critical lifelong writing skills.</p>
          </div>
        </div>

        <div className={styles.hauntToolsContainer}>

          <div className={styles.hauntTool}>
            <div className={styles.image}>
              <LazyLoadImage src={HauntStory} alt="" effect="blur" />
            </div>
            <div className={styles.toolBody}>
              <h4>Story Writing</h4>
              <p>Group and individual story writing activities that get published!</p>
            </div>
          </div>

          <div className={styles.hauntTool}>
            <div className={styles.image}>
              <LazyLoadImage src={HauntEssay} alt="" effect="blur" />
            </div>
            <div className={styles.toolBody}>
              <h4>Journal Writing</h4>
              <p>Your child’s ‘go to’ place to write about anything and everything.</p>
            </div>
          </div>

          <div className={styles.hauntTool}>
            <div className={styles.image}>
              <LazyLoadImage src={HauntJournal} alt="" effect="blur" />
            </div>
            <div className={styles.toolBody}>
              <h4>Essays and more!</h4>
              <p>Engaging, relevant activities to consistently improve writing skills.</p>
            </div>
          </div>

        </div>

        <Link to="/auth/parent/signup" className={styles.orangeBtn}>Subscribe to Family+</Link>

        <div id='beeContainer' className={styles.beeContainer}>

          <div className={styles.beeHeader}>
            <img src={the2021} alt='the 2021' />
            <h3>Writing Bee Qualifying Rounds</h3>
          </div>

          <p>
            Under the supervision of a certified educator, your child will have the opportunity to participate in the 2021 Writing Bee and write alongside their favorite author! From now until the end of April, The Haunt (Escribli’s writing club) will be conducting Writing Bee Qualifying sessions giving all participants the chance to advance to The Finals and compete to be the 2021 Writing Bee Champion. It’s easy! Just follow these simple steps:
          </p>

          <div className={styles.beeStepContainer}>

            <div className={styles.beeStep}>
              <span>Register as a Parent/Guardian on the Escribli Families page</span>
            </div>

            <div className={styles.beeStep}>
              <span>Subscribe to Family+</span>
            </div>

            <div className={styles.beeStep}>
              <span>See when the next Qualifying round takes place, and make sure your child is ready to compete!</span>
            </div>

          </div>


          <Link to="/auth/parent/signup" className={styles.orangeBtn}>Subscribe to Family+</Link>

        </div>


      </div>
    </section>
  );
}

export default FamilyPlus;